import { FC } from 'react'
import LocationIcon from '@components/Location/reusable/LocationIcon'
import Title from '@components/Location/reusable/Title'
import Subtitle from '@components/Location/reusable/Subtitle'
import LocationSearchByZip from '@components/Location/reusable/LocationSearchByZip'
import styles from '@components/Location/Location.module.scss'
import LocationCard from '@components/Location/reusable/LocationCard'
import Map from '@components/Location/reusable/Map'
import { FaRegMap, FaList } from 'react-icons/fa'

import {
  LocationProps,
  OnCardClickType,
} from '@components/Location/location.types'
import useMap from '@components/Location/reusable/Map/useMap'
import NoLocationsFound from '@components/Location/reusable/NoLocationsFound'
import { organizeLocations } from '@components/Location/utils/locationFunctions'

const Mobile: FC<LocationProps> = ({
  allLocations,
  locationsInArea,
  zipCodePosition,
  zipCode,
}) => {
  const map = useMap({
    allLocations,
    locationsInArea,
    zipCode,
    zipCodePosition,
  })

  const {
    state: { locationsOnMap, isVisible },
    handlers: { changePosition },
  } = map
  const onCardClick: OnCardClickType = ({ lat, lng }) => {
    if (!lat || !lng) return
    map.handlers.showMap()
    changePosition(Number(lat), Number(lng))
  }

  return (
    <div className="lg:hidden">
      <header className="text-center pt-6">
        <Title />
        <Subtitle />
      </header>
      <div className="my-2 flex flex-row justify-center items-center gap-2 h-full">
        <LocationIcon />
        <LocationSearchByZip zipCodePosition={zipCodePosition} />
      </div>

      <div className={map.state.isVisible ? '' : 'hidden'}>
        <Map {...map} allLocations={allLocations} />
        <button
          className="text-sm shadow-xl bottom-shadow absolute bottom-4 left-1/2 transform -translate-x-1/2 bg-[#3571AE] text-white px-8 py-2 rounded-full flex items-center gap-2"
          onClick={() => {
            map.handlers.hideMap()
          }}
        >
          <FaList />
          LIST VIEW
        </button>
      </div>

      <div
        className={`flex flex-col gap-4 ${map.state.isVisible ? 'hidden' : ''}`}
      >
        <div
          style={{ height: '70vh' }}
          className={`flex flex-col gap-2 overflow-y-auto ${styles.customScrollbar}`}
        >
          {!isVisible && locationsOnMap.length ? (
            organizeLocations(locationsOnMap, locationsInArea).map(
              (location) => (
                <LocationCard
                  key={location.id}
                  location={location}
                  onCardClick={onCardClick}
                />
              )
            )
          ) : (
            <NoLocationsFound />
          )}
        </div>
        <button
          className="text-sm shadow-xl bottom-shadow absolute bottom-4 left-1/2 transform -translate-x-1/2 bg-[#3571AE] text-white px-8 py-2 rounded-full flex items-center gap-2"
          onClick={map.handlers.showMap}
        >
          <FaRegMap />
          MAP VIEW
        </button>
      </div>
    </div>
  )
}

export default Mobile
